import React from "react";
import { FloatingMenu } from "@amzn/finergywebcomponents";

export function FinergyFloatingMenu(props: any) {
  const orgId = props.orgId;

  const FinergyMenu = FloatingMenu as (
    props: Parameters<typeof FloatingMenu>[0]
  ) => JSX.Element;

  return (
    <FinergyMenu
      homePageOrgId={orgId}
      iconTopMargin={15}
      iconLeftMargin={10}
      openMenuTopMargin={56}
    />
  );
}